
import { ensure_number } from './../type_utils/index.js';
// take N args and coerce them all to numbers
export function safeNums(...args: Array<number | string | null | undefined>): number[] {
  return args.map(ensure_number);
}

// divide the first value by each of the following
export function safeAdd(...args: Array<number | string | null | undefined>): number {
  const [head, ...rest] = safeNums(...args);
  // if we don’t have a head or any divisor is zero, bail
  return rest.reduce((acc, d) => acc + d, head);
}


// divide the first value by each of the following
export function safeSubtract(...args: Array<number | string | null | undefined>): number {
  const [head, ...rest] = safeNums(...args);
  // if we don’t have a head or any divisor is zero, bail
  return rest.reduce((acc, d) => acc - d, head);
}

// divide the first value by each of the following
export function safeDivide(...args: Array<number | string | null | undefined>): number {
  const [head, ...rest] = safeNums(...args);
  // if we don’t have a head or any divisor is zero, bail
  if (head === 0 || rest.some((d) => d === 0)) return 0;
  return rest.reduce((acc, d) => acc / d, head);
}

// multiply all the values together
export function safeMultiply(...args: Array<number | string | null | undefined>): number {
  const nums = safeNums(...args);
  // if any number is zero, result is zero
  if (nums.includes(0)) return 0;
  return nums.reduce((acc, n) => acc * n, 1);
}

// round a value to two decimals by percent
export function roundPercentage(x: any): number {
  const pct = safeMultiply(ensure_number(x), 100);
  return safeDivide(Math.round(pct), 100);
}
export function exponential(i: number, k: number) {
  return i * (10 ** (k))

}

export function isZero(obj:any){
  if (obj==0){
    return true
  }
  return false
}
